module.exports = __webpack_public_path__ + "img/nathalie_de_loeper-mobile.16680a6a.webp";